import React from 'react';
import PropTypes from 'prop-types';
import { SelectField, TextField } from 'react-admin';
import EjectedDatagrid from '../../../components/ejected/Datagrid';
import TextFieldWithDate from '../../../components/TextFieldWithDate';
import TextFieldWithPrice from '../../../components/TextFieldWithPrice';
import TextLabelWithPercantage from '../../../components/TextFieldWithPercantage';

const Datagrid = ({
  edit, create, total, subjects, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC' }}
    create={create}
    edit={edit}
    width="516px"
    {...rest}
  >
    <SelectField
      label="Тематика"
      source="id"
      choices={subjects}
      customstyles={{
        width: '80px',
        background: '#606060'
      }}
      optionValue="key"
      optionText="name"
    />
    <TextLabelWithPercantage source="percent" label="%" customstyles={{ width: '64px', background: '#606060' }} />
    <TextField source="count" label="Записи" customstyles={{ width: '64px', background: '#2C9BC3' }} cellstyles={{ color: '#2C9BC3' }} />
    <TextLabelWithPercantage source="ctr1" label="CR" customstyles={{ width: '64px', background: '#606060' }} />
    <TextField source="visited" label="Приход" customstyles={{ width: '64px', background: '#35CD59' }} cellstyles={{ color: '#35CD59', fontWeight: 'bold' }} />
    <TextLabelWithPercantage source="ctr2" label="CR" customstyles={{ width: '64px', background: '#606060' }} />
    <TextField source="paymentsCount" label="Оплата" customstyles={{ width: '64px', background: '#606060' }} />
    <TextFieldWithPrice source="paymentsAverage" label="Ср. Чек" customstyles={{ width: '64px', background: '#606060' }} />
    <TextFieldWithPrice source="paymentsTotal" label="Сумма" customstyles={{ width: '64px', background: '#606060' }} />
    <TextFieldWithPrice source="cac" label="CAC" customstyles={{ width: '64px', background: '#606060' }} />
    <TextFieldWithPrice source="roi1" label="ROI1" customstyles={{ width: '64px', background: '#606060' }} />
    <TextFieldWithPrice source="roi2" label="ROI2" customstyles={{ width: '64px', background: '#606060' }} />
  </EjectedDatagrid>
);

Datagrid.defaultProps = {
  subjects: []
};

Datagrid.propTypes = {
  create: PropTypes.func,
  edit: PropTypes.func,
  subjects: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
};

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/admin/statistics_subject/Datagrid.js